const initials = (name = "") =>
  name
    .split(" ")
    .map((_) => _[0])
    .join("");

const storage = localStorage;

const sum = (data = []) => data.reduce((a, b) => a + b, 0);

const isEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const isJSON = (str) => {
  let value = typeof str !== "string" ? JSON.stringify(str) : str;
  try {
    value = JSON.parse(value);
  } catch (e) {
    return false;
  }

  return typeof value === "object" && value !== null;
};

const toCurrency = (amount) => `${amount} Kr`;

const maskLicenseKey = (value) =>
  !value
    ? ""
    : value
        .match(/.{1,4}/g)
        .join(" ")
        .toUpperCase();

const toCapitalCase = (str) =>
  !str
    ? ""
    : str
        .split(" ")
        .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");

const ellipseMe = (value = "", max = 24) =>
  `${value.slice(0, max)}${!!value.slice(max) ? "..." : ""}`;

const isObject = (value) => typeof value === "object" && !Array.isArray(value);

const formatPhone = (value) => {
  if (!value) return value;
  let cleaned = value.replace(/[\s-]/g, "");
  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  } else if (cleaned.startsWith("0")) {
    cleaned = "+46" + cleaned.slice(1);
  }
  return cleaned;
};

const getCssVar = (name = "") =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(`--${name}`)
    .trim();

const Tools = {
  sum,
  isJSON,
  storage,
  isEmail,
  initials,
  isObject,
  ellipseMe,
  getCssVar,
  toCurrency,
  formatPhone,
  toCapitalCase,
  maskLicenseKey,
};

export default Tools;
